export default "__VITE_ASSET__Dg6yDE3b__"